export const STRATEGIES = ['bypass', 'and', 'or'] as const;

export const DELIMITER = ':' as const;
